/* eslint-disable */
import React from "react";
import { RootState } from "Store/mainStore";
import { useSelector, useDispatch } from "react-redux";
import Tabs, { Tab } from "@nokia-csf-uxr/ccfk/Tabs";
import { setSelectedContractTab } from "Store/contentState/commonSlice";

const ARIA_LABEL_TEXT_1 = 'To select Tab ';
const ARIA_LABEL_TEXT_2 = ' press spacebar';

const CommonContractsTabs: React.FC = () => {
    const dispatch = useDispatch();
    const { selectedTab } = useSelector((state: RootState) => state.common.commonContractTabDetails);
    const tabData = useSelector((state: RootState) => state.common.commonContractTabDetails.tabData);

    const handleTabSelect = (id: number, children: string) => {
        console.log("handleTabSelect", id, children);
        dispatch(setSelectedContractTab({ id, children }));
    };

    return (
        <>
            <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between',
                minWidth: '0',
                flexShrink: 0,
                marginBottom: '16px'
            }}>
                <Tabs alignment="left" fullWidth={false} variant="default">
                    {tabData.map(({ tab }, i) => {
                        const ariaMainText = tab && tab.label;
                        return (
                            <Tab
                                id={`contract-tab-${i}`}
                                aria-label={selectedTab === i ? `${ariaMainText}` : `${ARIA_LABEL_TEXT_1} ${ariaMainText} ${ARIA_LABEL_TEXT_2} `}
                                aria-controls={`contract-tab-content-${i}`}
                                aria-posinset={(tab && tab.label) ? i + 1 : undefined}
                                aria-setsize={(tab && tab.label) ? tabData.length : undefined}
                                role="option"
                                key={`contract-tab-${i}`}
                                selected={selectedTab === i}
                                onSelect={() => handleTabSelect(i, tab.children)}
                                style={{ 
                                    whiteSpace: 'nowrap',
                                    minWidth: 'fit-content',
                                    flexShrink: 0
                                }}
                                {...tab}
                                // Render visible label but keep internal children identifier intact
                                children={tab.label || tab.children}
                            />
                        );
                    })}
                </Tabs>
            </div>
        </>
    )
}

export default CommonContractsTabs;
